/**
 * Return the short institution mark used in portal navigation.
 * System Settings can provide an explicit initials value; otherwise derive a
 * compact fallback from the configured institution name.
 */
export const getInstitutionInitials = (institution = {}) => {
  const configured = String(institution?.initials || '').trim();
  // Preserve the exact casing captured in System Settings (for example, UoEm).
  if (configured) return configured;

  const name = String(institution?.name || '').trim();
  if (!name) return 'IN';
  const words = name.split(/\s+/).filter(Boolean);
  if (words.length > 1) return words.slice(0, 3).map(word => word[0]).join('').toUpperCase();
  return name.replace(/[^a-z0-9]/gi, '').slice(0, 3).toUpperCase() || 'IN';
};
